import createReactComponent from '../createReactComponent';
export default createReactComponent('sdk', 'IconSdk', [
  [
    'path',
    {
      d: 'M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M17 8v8', key: 'svg-1' }],
  ['path', { d: 'M21 8l-3 4l3 4', key: 'svg-2' }],
  ['path', { d: 'M17 12h1', key: 'svg-3' }],
  [
    'path',
    { d: 'M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z', key: 'svg-4' },
  ],
]);
